import React from "react";
export const HomeSvg = () => (
  <svg
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 512 512"
  >
    <path
      d="M197.3,170.7h-160C16.7,170.7,0,153.9,0,133.3v-96C0,16.7,16.7,0,37.3,0h160c20.6,0,37.3,16.7,37.3,37.3v96
	C234.7,153.9,217.9,170.7,197.3,170.7z M37.3,32c-2.9,0-5.3,2.4-5.3,5.3v96c0,2.9,2.4,5.3,5.3,5.3h160c2.9,0,5.3-2.4,5.3-5.3v-96
	c0-2.9-2.4-5.3-5.3-5.3H37.3z"
    />
    <path
      d="M197.3,512h-160C16.7,512,0,495.3,0,474.7v-224c0-20.6,16.7-37.3,37.3-37.3h160c20.6,0,37.3,16.7,37.3,37.3v224
	C234.7,495.3,217.9,512,197.3,512z M37.3,245.3c-2.9,0-5.3,2.4-5.3,5.3v224c0,2.9,2.4,5.3,5.3,5.3h160c2.9,0,5.3-2.4,5.3-5.3v-224
	c0-2.9-2.4-5.3-5.3-5.3H37.3z"
    />
    <path
      d="M474.7,512h-160c-20.6,0-37.3-16.7-37.3-37.3v-96c0-20.6,16.7-37.3,37.3-37.3h160c20.6,0,37.3,16.7,37.3,37.3v96
	C512,495.3,495.3,512,474.7,512z M314.7,373.3c-2.9,0-5.3,2.4-5.3,5.3v96c0,2.9,2.4,5.3,5.3,5.3h160c2.9,0,5.3-2.4,5.3-5.3v-96
	c0-2.9-2.4-5.3-5.3-5.3H314.7z"
    />
    <path
      d="M474.7,298.7h-160c-20.6,0-37.3-16.7-37.3-37.3v-224c0-20.6,16.7-37.3,37.3-37.3h160C495.3,0,512,16.7,512,37.3v224
	C512,281.9,495.3,298.7,474.7,298.7z M314.7,32c-2.9,0-5.3,2.4-5.3,5.3v224c0,2.9,2.4,5.3,5.3,5.3h160c2.9,0,5.3-2.4,5.3-5.3v-224
	c0-2.9-2.4-5.3-5.3-5.3H314.7z"
    />
  </svg>
);
